import { api, ApiRequestConfig } from './api';
import { FetchLoyaltyRankDTO } from '../types/loyalty';
import { LOYALTY_ACCOUNT_API } from './constants';

interface IGetLoyaltyRankParams {
  regionId: string;
  loyaltyAccountIdentifier: string;
}

export const getLoyaltyRankRequest = (
  { regionId, loyaltyAccountIdentifier }: IGetLoyaltyRankParams,
  config: ApiRequestConfig,
) =>
  api.get<FetchLoyaltyRankDTO>(
    `${LOYALTY_ACCOUNT_API}/${loyaltyAccountIdentifier}/rank`,
    { regionId },
    config,
  );
